// Pantalla mostrada cuando el usuario completa el login Microsoft pero su
// correo no está en la lista blanca (allowed-users.js).
//
// Es esperable, por ejemplo, si alguien del tenant JMA Seguridad ajeno al
// proyecto intenta acceder. Se le permite cerrar sesión para volver a
// intentar con otra cuenta.

import { html } from 'htm/preact'
import { logout, getUserEmail } from '../auth/auth-provider.js'

export function UnauthorizedScreen() {
  const email = getUserEmail()
  return html`
    <div class="auth-screen">
      <div class="auth-card auth-card--alert">
        <img
          class="auth-card__logo"
          src="/logos/jma-cybersec-horizontal.png"
          alt="JMA CyberSec"
        />
        <h1 class="auth-card__title">Acceso no autorizado</h1>
        <p class="auth-card__subtitle">
          La cuenta <strong>${email || 'desconocida'}</strong> no está
          habilitada para el Dashboard JMA AFAC. Solicita acceso al
          administrador del proyecto si lo necesitas.
        </p>
        <button
          type="button"
          class="btn btn--secondary auth-card__button"
          onClick=${() => logout()}
        >
          Cerrar sesión
        </button>
      </div>
    </div>
  `
}
